import { A, Div, Icon, IconText, Section } from "trunx";
import { LeafletPanelBody, LeafletPanelHeading } from "../shared/LeafletPanel";
import { faCheckSquare, faSquare } from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IStaticLayerFolder, IStaticLayerSubFolder } from "../models/Layers";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";
import { useLocaleContext } from "../contexts/LocaleContext";
import { useRootStore } from "../models/Root";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";

interface StaticLayerFolderPanelProps {
  model: IStaticLayerFolder | IStaticLayerSubFolder;
  back: () => void;
}
const StaticLayerFolderPanel = ({
  model: { title, layers, cite_text, cite_url },
  back,
}: StaticLayerFolderPanelProps) => {
  const {
    dict: {
      panel: { layers: dict },
    },
  } = useLocaleContext();

  const { layers: layerStore } = useRootStore();

  const LayerMenu = observer(
    ({ layers }: { layers: (IStaticLayerFolder | IStaticLayerSubFolder)["layers"] }) => {
      return (
        <Div bulma="menu">
          <ul className="menu-list">
            {layers.map((item: any) => {
              if (item.source !== undefined) {
                // Static layer
                const { name, toggle, visible } = item;
                return (
                  <li key={name} onClick={toggle}>
                    <IconText>
                      <Icon bulma="is-left">
                        <FontAwesomeIcon
                          icon={visible ? faCheckSquare : faSquare}
                        />
                      </Icon>
                      <span>{name}</span>
                    </IconText>
                  </li>
                );
              } else if (item.layers !== undefined) {
                // Sub-folder
                const { title, toggle, anyVisible } = item;
                return (
                  <li key={title}>
                    <IconText>
                      <Icon bulma="is-left" onClick={toggle}>
                        <FontAwesomeIcon
                          icon={anyVisible ? faCheckSquare : faSquare}
                        />
                      </Icon>
                      <span
                        className="is-link"
                        onClick={() => layerStore.setOpenLayerPanel(item)}
                      >
                        {title}
                      </span>
                      <Icon
                        className="is-right"
                        onClick={() => layerStore.setOpenLayerPanel(item)}
                      >
                        <FontAwesomeIcon icon={faCaretRight} />
                      </Icon>
                    </IconText>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </Div>
      );
    }
  );

  let cite_: ReactNode = undefined;
  if (cite_text !== undefined) {
    if (cite_url !== undefined) {
      cite_ = (
        <A
          bulma="is-underlined"
          href={cite_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {cite_text}
        </A>
      );
    } else {
      cite_ = cite_text;
    }
  }

  return (
    <Div bulma="panel">
      <Div bulma="panel-heading">
        <LeafletPanelHeading title={title} close={back} />
      </Div>
      <LeafletPanelBody>
        <Section>
          <LayerMenu layers={layers}></LayerMenu>
        </Section>
        {cite_ !== undefined && (
          <Section>
            <i>{dict.source} {cite_}</i>
          </Section>
        )}
      </LeafletPanelBody>
    </Div>
  );
};

export default observer(StaticLayerFolderPanel);
